
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#8689A4","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5","d":"M16.953 18.076v-3.169m-.03 7.017v3.169m1.953-5.025h3.277"}}),_c('path',{attrs:{"stroke":"#8689A4","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5","d":"M18.877 12.792a.806.806 0 00-.819-.792H15.85c-.452 0-.82.355-.82.792v1.197c0 .437.368.792.82.792h2.208c.453 0 .82-.355.82-.792v-1.197zM15 27.208c0 .437.367.792.82.792h2.207c.453 0 .82-.355.82-.792V26.01c0-.437-.367-.792-.82-.792H15.82a.806.806 0 00-.819.792v1.197zm11-7.744c0-.437-.367-.792-.82-.792h-2.207c-.453 0-.82.355-.82.792v1.197c0 .437.367.792.82.792h2.208a.806.806 0 00.819-.792v-1.197zm-9.047-1.26l1.923 1.86-1.923 1.86-1.923-1.86 1.923-1.86z","clip-rule":"evenodd"}}),_c('rect',{attrs:{"width":"39","height":"39","x":".5","y":".5","stroke":"#D5D8E5","rx":"5.5"}})])
          )
        }
      }
    